module.exports = __webpack_public_path__ + "img/icon_upload_default copy 4.8c55417b.svg";